import * as actionTypes from "./actionTypes";
import store from "../store";
import { getEntrySummaryForm } from "../api/getEntrySummaryData";
import { convertGACItems } from "../components/entrySummaryForms/util/assignValues";
import { initializeGAC, initializeECCCFlag } from "./initializeValues";

export const getInitialGAC = () => ({
  pga: {
    cbsaPgaType: "GAC",
    cbsaPgaSubProgramType: "Steel",
  },
  elements: [
    {
      elementName: "gacLpcoDocType",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "gacLpcoReference",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "gacCountryOfMeltAndPour",
      uiVals: [{ id: 0, value: "" }],
    },
  ],
});
export const getInitialGAC1 = () => ({
  pga: {
    cbsaPgaType: "GAC",
    cbsaPgaSubProgramType: "Agriculture",
  },
  elements: [
    {
      elementName: "gacLpcoDocType",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "gacLpcoReference",
      uiVals: [{ id: 0, value: "" }],
    },
  ],
});
export const toggleGAC = (merchandiseId, lineItemIndex, pgaPayload) => ({
  type: actionTypes.TOGGLE_GAC(lineItemIndex),
  payload: {
    merchandiseId,
    pgaPayload,
  },
});

export function toggleGacForm(
  merchandiseId,
  lineItemIndex,
  pgaPayload,
  pgaProgram
) {
  store.dispatch(toggleGAC(merchandiseId, true, lineItemIndex, pgaPayload));
  getEntrySummaryForm(window.shipmentId)
    .then((response) => {
      store.dispatch(
        initializeECCCFlag(
          response.data.eventMessage.descriptionOfMerchandise
            .merchandiseLineItems
        )
      );

      const responseData =
        response.data.eventMessage.descriptionOfMerchandise
          .merchandiseLineItems[lineItemIndex].pgaDetails.pgaDetails;
      const getPgaType = (responseData) => {
        if (Array.isArray(responseData) && responseData.length) {
          for (let i = 0; i < responseData.length; i++) {
            if (responseData[i].pga.cbsaPgaType == "GAC") {
              return responseData[i].pga.cbsaPgaSubProgramType;
            }
          }
          return undefined;
        } else {
          return undefined;
        }
      };
      const programType = getPgaType(responseData) || pgaProgram;
      const initialData =
        programType === "Steel" ? getInitialGAC() : getInitialGAC1();

      if (responseData) {
        for (let i = 0; i < responseData.length; i++) {
          if (responseData[i].pga.cbsaPgaType === "GAC") {
            const data = convertGACItems(responseData[i], programType);
            return store.dispatch(initializeGAC(lineItemIndex, data));
          }
        }
        return store.dispatch(initializeGAC(lineItemIndex, initialData));
      } else {
        return store.dispatch(initializeGAC(lineItemIndex, initialData));
      }
    })
    .catch((err) => {
      console.error("GAC Error", err);
      let error = {
        GACError: err,
      };
      return store.dispatch(
        initializeGAC(lineItemIndex, {
          error: `ERROR: Could not retrieve GAC Certification for the associated HTS and Merchandise ID ${merchandiseId} ${error}`,
        })
      );
    });
}

export function updateGacField(lineItemIndex, field, payload) {
  return {
    type: actionTypes.UPDATE_GAC_FIELD(lineItemIndex),
    payload,
    field,
  };
}

export function saveGacField(
  merchandiseId,
  lineItemIndex,
  field,
  level,
  invoiceId
) {
  return {
    type: actionTypes.SAVE_GAC_FIELD(lineItemIndex),
    field,
    merchandiseId,
    level,
    invoiceId,
  };
}
